import React from "react";
import { InputWrapper, StyledInput } from "./style";
import Label from "../style";
export default ({
  type = "text",
  onChange,
  placeholder,
  label,
  value,
  name,
  id,
  prefix,
  ...rest
}) => {
  return (
    <InputWrapper>
      <div>
        <Label title={label} />
      </div>
      <StyledInput
        prefix={prefix}
        type={type ? type : "text"}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        name={name}
        id={id}
        {...rest}
      />
    </InputWrapper>
  );
};
